<template>
  <el-card>
    <div class="group-detail">
      <SettingForm @getAttachment="getAttachment" />
      <Iphone
        class="iphone"
        :attachment="attachment"
      />
    </div>
  </el-card>
</template>

<script>
import SettingForm from './comps/customerGroupDetail/form.vue'
import Iphone from './comps/customerGroupDetail/iphone.vue'
export default {
  components: {
    SettingForm,
    Iphone
  },
  data () {
    return {
      attachment: []
    }
  },
  mounted () {},
  methods: {
    getAttachment (data) {
      this.attachment = data
    }
  }
}
</script>

<style lang="scss" scoped>
.group-detail {
  display: flex;
  .tips {
    color: #9a9097;
    font-size: 12px;
  }
  .iphone {
    width: 400px;
  }
}
</style>
